import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
dayjs.extend(calendar);

export const formatDateToCalendar = (dateString: string) => {
  try {
    const date = dayjs(dateString);
    return date.format("DD/MM/YYYY");
  } catch {}
  return "";
};

export const fullDateTimeFormat = "ddd MMM D YYYY h:mm A";

export const fullDateTimeFormatSuccinct = "D MMM YYYY h:mm A";

export const HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm", // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss", // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS", // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD", // <input type="date" />
  TIME: "HH:mm", // <input type="time" />
  TIME_SECONDS: "HH:mm:ss", // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS", // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW", // <input type="week" />
  MONTH: "YYYY-MM", // <input type="month" />
  MONTH_DAY: "MMM DD",
};

export const formatDate = (dateString: string, format: string) => {
  try {
    const date = dayjs(dateString);
    return date.format(format);
  } catch {}
  return "";
};
